import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightKeyboardHints = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 19,
	viewBox: "0 0 25 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.49463 1.28223H20.4946C22.4276 1.28223 23.9946 2.84923 23.9946 4.78223V14.7822C23.9946 16.7152 22.4276 18.2822 20.4946 18.2822H4.49463C2.56163 18.2822 0.994629 16.7152 0.994629 14.7822V4.78223C0.994629 2.84923 2.56163 1.28223 4.49463 1.28223Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.49463 1.28223H20.4946C22.4276 1.28223 23.9946 2.84923 23.9946 4.78223V14.7822C23.9946 16.7152 22.4276 18.2822 20.4946 18.2822H4.49463C2.56163 18.2822 0.994629 16.7152 0.994629 14.7822V4.78223C0.994629 2.84923 2.56163 1.28223 4.49463 1.28223Z",
			stroke: "#D9D9D9",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1614 7.37394L10.1614 12.1901C10.1614 12.3346 10.3903 12.4152 10.5466 12.3258L14.7381 9.91769C14.858 9.84876 14.858 9.71604 14.7381 9.64637L10.5466 7.23828C10.3903 7.14882 10.1614 7.22948 10.1614 7.37394Z",
			fill: "black",
			fillOpacity: .85
		})
	]
});
const ForwardRef = forwardRef(SvgRightKeyboardHints);
export { ForwardRef as ReactComponent };
